<template>
  <div class="page">
    <div class="header-menu">
      <navBar v-model="objSave"></navBar>
    </div>
    <div class="page-content">
      <div class="tabs">
        <span :class="{'active':currentIndex==index}" @click="selectTab(tab.value,index)" v-for="tab,index in registerTabs">{{$t(tab.label)}}</span>
      </div>
      <div class="register-wrapper">
        <component :currentView="currentView" :is="currentView"></component>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }

  .tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tabs span {
    flex: 2;
    display: inline-block;
    text-align: center;
    height: 1.064rem;
    line-height: 1.064rem;
    box-sizing: border-box;
  }

  .active {
    border-bottom: 0.02rem solid #12a3ff;
    background-color: #fff;
  }

  .register-wrapper {
    background-color: #fff;
  }

</style>
<script>
  import userRegister from './modules/user-register.vue'
  import companyRegister from './modules/company-register.vue'
  import navBar from '../modules/navBar.vue'
  import accountInformation from './modules/accountInformation.vue'
  export default {
    data() {
      return {
        objSave: {
          centerTitle: 'system.Register',
        },
        registerTabs: [{
          label:'system.UserRegister',
          value: 'userRegister',
        }, {
          label: 'system.CompanyRegister',
          value: 'companyRegister',
        }],

        currentView: 'userRegister',
        currentIndex: 0,
      }
    },
    methods: {
      selectTab(value, index) {
        let __self = this;
        __self.currentView = value;
        __self.currentIndex = index;
      },
    },
    components: {
      navBar,
      accountInformation,
      userRegister,
      companyRegister
    }
  }

</script>
